import { useCallback, useEffect, useRef, useState } from "react";

import { AgencyNoticeHeaderBanner } from "./agency-notice-header-banner";

export const useAgencyNoticeHeaderBannerViewModel = ({
  agencyNotice,
  onClose,
  onDismiss,
}: React.ComponentProps<typeof AgencyNoticeHeaderBanner>) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isSeeMoreButtonVisible, setIsSeeMoreButtonVisible] = useState(false);

  const contentContainerRef = useRef<HTMLDivElement>(null);
  const contentParagraphRef = useRef<HTMLParagraphElement>(null);

  const close = useCallback(() => {
    onClose();
  }, [onClose]);

  const dismiss = useCallback(() => {
    onClose();

    onDismiss();
  }, [onClose, onDismiss]);

  const toggleIsExpanded = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, []);

  useEffect(() => {
    const resizeHandler = () => {
      if (!contentContainerRef.current || !contentParagraphRef.current) {
        return;
      }

      if (isExpanded) {
        return;
      }

      const rightPadding =
        contentContainerRef.current.getBoundingClientRect().right -
        contentParagraphRef.current.getBoundingClientRect().right;

      if (rightPadding <= 0) {
        setIsSeeMoreButtonVisible(true);
      } else {
        setIsSeeMoreButtonVisible(false);
      }
    };

    resizeHandler();

    window.addEventListener("resize", resizeHandler);

    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, [agencyNotice, contentContainerRef, contentParagraphRef, isExpanded]);

  return {
    contentContainerRef,
    contentParagraphRef,
    close,
    dismiss,
    isExpanded,
    isSeeMoreButtonVisible,
    toggleIsExpanded,
  };
};
